/* eslint-disable */
var productsData = [
  {
    id: 1,
    img: require("@/assets/img/kits/1.jpg"),
    class: "STD 01",
    price: "1370 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Number Flowers",
        "Addition",
        "Equal Addition",
        "Addition Table",
        "Addition Net",
        "Complement with respect to 9 & 10",
        "Subtraction",
        "Hidden Number",
        "Concept of Zero",
        "Longer & Shorter",
        "Grouping & Matching",
        "Shapes & Colours",
        "Data Sketch",
        "Patterns & Missing Numbers",
        "Dotted Drawings",
        "Path Finding",
        "Ascending & Descending Order",
        "Place Value",
        "Number Tree",
        "Place Value Strip",
        "May I Know You",
        "Currency",
        "Ordering",
        "Guess the Dots",
        "Growing Patterns"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 2,
    img: require("@/assets/img/kits/2.jpg"),
    class: "STD 02",
    price: "1400 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Multiplication of 9",
        "Place Value Strip",
        "Addition Table",
        "Complement with respect to 9 & 10",
        "Equal Addition",
        "Subtraction by Removal",
        "Skip Counting",
        "Dotted Rectangles",
        "Currency & Money Management",
        "Data Sketch",
        "Path Finding",
        "Grouping & Matching",
        "Dotted Drawings",
        "Decoding Ring",
        "Beauty of One",
        "Pattern & Missing Number",
        "Shapes & Colours",
        "Number Flowers",
        "Hidden Numbers",
        "Place Value",
        "Ordering",
        "Number Tree",
        "May I Know You",
        "Guess the Dots",
        "Addition Pyramid",
        "Growing Patterns",
        "Addition & Subtraction",
        "Board Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 3,
    img: require("@/assets/img/kits/3.jpg"),
    class: "STD 03",
    price: "1430 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Place Value Strips",
        "Multiplication of 9",
        "Even & Odd Numbers",
        "Beauty of One & Two",
        "Multiplication Table",
        "Dotted Rectangles",
        "Pattern of Multiplication",
        "Divisibility By Grouping",
        "Mirror Image",
        "Currency & Money Management",
        "Smart Charting - Shapes & Colours",
        "Decoding Ring",
        "Data Sketch",
        "Pattern & Missing Numbers",
        "Ten Balls in Five Lines",
        "Multiples & Factors",
        "Cross in a Multiplication Grid",
        "Number Flowers",
        "Hidden Numbers",
        "Place Value",
        "Clock",
        "Quantities",
        "Conversion",
        "Quantity",
        "Conversion",
        "Operation Board Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 4,
    img: require("@/assets/img/kits/4.jpg"),
    class: "STD 04",
    price: "1450 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        " Multiplication Table",
        "a x b = b x a (Commutative Multiplication)",
        "Multiplication of 9",
        "a + (b + c) = (a + b) + c",
        "Place Value Strip",
        "Multiples & Factors",
        "Quantities",
        "Fractional Kit",
        "Fraction Chart",
        "Fraction Scale",
        "Operations on Fraction with Same Denominator",
        "Multiplication of Fraction by a Number",
        "Hidden Number (Multiplication, Division & Fraction)",
        "Concept of Division",
        "Terms of Division",
        "3 x 3 Magic Square",
        "Beauty of Two",
        "Find the Area & Perimeter",
        "Percent & Percentage",
        "Age Detector Table",
        "Geo Board",
        "Pizza Cut",
        "Beauty of Pattern in Multiplication",
        "Types of Numbers",
        "Ten Balls In Five Lines",
        "Order of Operation",
        "Missing Number",
        "Mysterious 37",
        "Rules of Fraction",
        "Conversion",
        "Quantity Conversion",
        "Wonders of Primes",
        "Images in a Mirror & Water",
        "Cross in Multiplication Grid",
        "Operation Board Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 5,
    img: require("@/assets/img/kits/5.jpg"),
    class: "STD 05",
    price: "1480 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Factorisation Chips",
        "Eratosthenes Table of Prime Numbers",
        "LCM & HCF Kit ",
        "LCM & HCF Short Cut",
        "Decimal Strips",
        "Decimals in Grid Paper",
        "Fractional Kit",
        "Fraction Chart",
        "Napier ’s bones",
        "Mysterious 37",
        "Beauty of Pattern in Multiplication",
        "Operation of Fraction witSame Denominators",
        "Beauty of 142857",
        "Operation of Fractions with different Denominators",
        "Funny Angles",
        "Age Detector Table",
        "Even & Odd Numbers ",
        "Magic Square for my Number",
        "Pizza Cut ",
        "Fraction Scale",
        "Multiplication of Fraction ",
        "by a Number",
        "Types of Numbers",
        "Multiples & Factors",
        "Rules of Fraction",
        "Multiples & LCM",
        "Conversion",
        "Quantity Conversion (King Henry)",
        "Roman Numbers",
        "Geometrical Shapes",
        "Area & Perimeter",
        "Parallel Scale Nomogram",
        "Net of Solids",
        "Quantities",
        "Wonders of Prime",
        "Images in Mirror & Water",
        "Domino Arrangement of",
        "Equalent Fractions",
        "Fraction Card Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 6,
    img: require("@/assets/img/kits/6.jpg"),
    class: "STD 06",
    price: "1530 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Integer Board with Coins",
        "LCM & HCF Kit",
        "Parallel Scale Nomogram",
        "Napier’s Bones",
        "Ramanujan Number",
        "Roman Numbers",
        "Fractional Kit",
        "Fraction Chart",
        "Decimals In Grid Paper",
        "Decimal Strips",
        "Funny Angles",
        "Geometrical Shapes",
        "Area & Perimeter",
        "Meet Triangles",
        "Symmetry",
        "Similarity & Congruency",
        "Algebraic Tiles",
        "Powers of 10",
        "Conversions",
        "Conversion in Fractions",
        "Sequential Inputs of 6",
        "Age Detector Table",
        "Operation on Fractions with ",
        "Same Denominator",
        "Operation on Fractions with ",
        "Different Denominator  ",
        "Multiplication of Fraction by a Number",
        "Division of Fraction with Natural Numbers",
        "Addition of Mixed Fraction with ",
        "Same Denominator",
        "Multiplication of Decimals",
        "Domino Arrangement of ",
        "Equivalent Fraction",
        "Images in Water & Mirror",
        "Multiples & LCM",
        "Wonders of Prime",
        "Net Of Solids ",
        "Geo Board",
        "Integer Board Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 7,
    img: require("@/assets/img/kits/7.jpg"),
    class: "STD 07",
    price: "1580 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Integer Board with Coins",
        "LCM & HCF Kit",
        "Parallel Scale Nomogram",
        "Napier’s Bones",
        "Ramanujan Number",
        "Roman Numbers",
        "Fractional Kit",
        "Fraction Chart",
        "Decimals In Grid Paper",
        "Decimal Strips",
        "Funny Angles",
        "Geometrical Shapes",
        "Area & Perimeter",
        "Meet Triangles",
        "Symmetry",
        "Similarity & Congruency",
        "Algebraic Tiles",
        "Powers of 10",
        "Conversions",
        "Conversion in Fractions",
        "Sequential Inputs of 6",
        "Age Detector Table",
        "Operation on Fractions with ",
        "Same Denominator",
        "Operation on Fractions with ",
        "Different Denominator  ",
        "Multiplication of Fraction by a Number",
        "Division of Fraction with Natural Numbers",
        "Addition of Mixed Fraction with ",
        "Same Denominator",
        "Multiplication of Decimals",
        "Domino Arrangement of ",
        "Equivalent Fraction",
        "Images in Water & Mirror",
        "Multiples & LCM",
        "Wonders of Prime",
        "Net Of Solids ",
        "Geo Board",
        "Integer Board Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 8,
    img: require("@/assets/img/kits/8.jpg"),
    class: "STD 08",
    price: "1620 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Types of Quadrilaterals",
        "Area of Rhombus",
        "Sum of Angles in a Triangle",
        "Pythagoras Theorem",
        "Bhaskara’s Proofs of Pythagoras Theorem",
        "Pythagoras Theorem with Tangram",
        "Circle Parts",
        "(a - b)2",
        "(a + b)2",
        "(a + b + c)2",
        "a2 - b2",
        "Circle Check",
        "Net of Solids",
        "Sum of Angles in a Quadrilateral",
        "Exterior Angle Property",
        "of a Quadrilateral",
        "Addition & Subtraction",
        "of Polynomials",
        "Products of Polynomials",
        "Binary Cards",
        "Patterns",
        "Honey Comb (Hexagon)",
        "Wonders of Primes",
        "Images in Water & Mirror",
        "Algebraic Identities",
        "Age Detector Table",
        "Congruence",
        "Linear Equation with ",
        "One Variable",
        "Mobius Ring",
        "Pascal’s Triangle",
        "Ramanujan Number",
        "Sequential Inputs",
        "Area of a Circle",
        "Angles in a Quadrilateral",
        "Angles in a Semicircle",
        "Polynomial Board Game"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 9,
    img: require("@/assets/img/kits/9.jpg"),
    class: "STD 09",
    price: "1680 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Circle Parts",
        "Area of a Circle",
        "Annular Ring",
        "Concentric Circle",
        "Area of Trapezium",
        "Net of Solids",
        "Value of Irrational Numbers on a ",
        "Number Line & Root Spiral of Theodorus",
        "Algebraic Tiles",
        "Linear Equation with One Variable",
        "Product of Polynomials",
        "Properties of Parallelogram",
        "Addition & Subtraction of Polynomials",
        "Factorisation of Polynomial ",
        "Similar Triangles",
        "Congruent Triangles",
        "Mobius Ring",
        "Chords & Angles",
        "Basic Proportionality Theorem",
        "Circle Check",
        "Real Numbers",
        "Chords & Tangents",
        "Coordinate Geometry",
        "Hidden Picture",
        "Pascal’s Triangle",
        "Missing Line Magic",
        "Fallacies",
        "Sequential Inputs",
        "Linear Equation with two Variables",
        "Cycloid",
        "Algebra in Tiles",
        "Wonders of Prime",
        "Images in Water & Mirror"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  },
  {
    id: 10,
    img: require("@/assets/img/kits/10.jpg"),
    class: "STD 10",
    price: "1680 INR",
    text:
      "A comprehensive range of maths kits created for use in the classroom.",
    data: {
      contents: [
        "Sum of First ‘n’ Natural Numbers",
        "Sum of First ‘n’ Odd Numbers",
        "Sum of First ‘n’ Even Numbers",
        "Circle Check",
        "Angles in Two Segments of a Circle",
        "Circum Center/ Circum Circle",
        "Incenter/ Incircle",
        "Concentric Circle",
        "Annular Ring",
        "Similar Triangle",
        "Side Split Theorem",
        "Value of Irrational Number on Number",
        "Line & Root Spiral of Theodorus",
        "Values of Trigonometric Ratios",
        "Net of Solids",
        "Linear Equation with One Variable",
        "Polynomials (Addition & Subtraction)",
        "Factorisation of Polynomials",
        "Mobius Ring",
        "Linear Equation with Two Variables",
        "Three Vessel Problem",
        "Coordinate Geometry",
        "Game of Number of Squares ",
        "Real Numbers",
        "Missing Square Magic",
        "Fallacies",
        "Binary cards",
        "Quadrants",
        "Sequential Inputs",
        "Trigonometric Fan ",
        "Trigonometric Hexagon",
        "Euler Line",
        "Area of Trapezium",
        "Cycloid",
        "Algebraic Identities",
        "Mid-Point Theorem",
        "Nature of Straight Line",
        "Quadratic Equation",
        "Palm Rule"
      ],
      others: [
        "Puzzles",
        "Demonstration Notes",
        "Mathematics Calendar",
        "Mathematics Dictionary"
      ]
    }
  }
];
export default productsData;
